/* eslint eslint-comments/no-use: off */
import {useCallback, useState, type HTMLAttributes, type RefAttributes} from 'react'

import {AnchoredOverlay} from '@primer/react'
import {ErrorWithRetry} from '@github-ui/error-with-retry'

import styles from './useItemPickerErrorFallback.module.css'

type useErrorOverlayProps = {
  errorMessage: string
  anchorElement?: (props: HTMLAttributes<HTMLElement> & RefAttributes<HTMLButtonElement>) => JSX.Element
  open?: boolean
}

export function useItemPickerErrorFallback({errorMessage, anchorElement, open = false}: useErrorOverlayProps) {
  const [errorOverlayOpened, setErrorOverlayOpened] = useState(open)

  const createFallbackComponent = useCallback(
    (retry: () => void) => {
      if (!anchorElement) {
        return null
      }
      return (
        <AnchoredOverlay
          width="medium"
          height="small"
          open={errorOverlayOpened}
          onOpen={() => setErrorOverlayOpened(true)}
          onClose={() => setErrorOverlayOpened(false)}
          renderAnchor={anchorElement}
        >
          <div className={styles.errorOverlayContainer}>
            <ErrorWithRetry message={errorMessage} retry={retry} className={styles.errorWithRetry} />
          </div>
        </AnchoredOverlay>
      )
    },
    [anchorElement, errorMessage, errorOverlayOpened],
  )

  return {createFallbackComponent}
}
